import { Button } from '../button/Button';

export interface ToastAction {
    label: string;
    onClick: () => void;
}

interface ToastMessageProps {
    message: string;
    action?: ToastAction;
}

export const ToastMessage: React.FC<ToastMessageProps> = ({ message, action }) => {
    if (!action) {
        return <>{message}</>;
    }

    return (
        <div className="flex flex-col items-start gap-2">
            <span>{message}</span>
            <Button type="button" size="sm" variant="primary" appearance="outline" onClick={action.onClick}>
                {action.label}
            </Button>
        </div>
    );
};
